export const emojis = [
	'🙂',
	'😊',
	'🤗',
	'😄',
	'😅',
	'😆',
	'😂',
	'🤣',
	'😘',
	'🥰',
	'😍',
	'🤩',
	'😇',
	'😎',
	'😋',
	'😜',
	'🙃',
	'😴',
	'🤯',
	'🥳',
];
